/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Cover from 'components/cover'
import { SvgWrapper } from '../svgwrapper'
import { Gas } from '../gas'
import Verkehr from 'images/verkehr.svg'
import Luzern from 'images/luzern.svg'
import Wallis from 'images/wallis.svg'
import { EmissionCounter } from 'components/emissioncounter'
import { LonzaAreal } from '../lonzaareal'
import { Link } from '@ta-interaktiv/contentbricks'
import renderHTML from 'react-render-html'

const ARTICLE_ID = '928089410471'
const isMobile = window.innerWidth < 600
const isTablet = window.innerWidth >= 600 && window.innerWidth <= 1024

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead
        articleId={ARTICLE_ID}
        inverted
        mediaName='dasmagazin'
        fullMediaName='Das Magazin'
        homepage='https://www.dasmagazin.ch'
      />
      <ThemeSwitch />

      <Cover
        title={
          isMobile ? 'Die Klimaschande von Visp' : 'Die Klimaschande von Visp'
        }
        subtitle={
          isMobile
            ? 'Eine einzige Fabrik im Wallis verursacht ein Prozent der gesamten Treibhausgasemissionen der Schweiz.'
            : 'Eine einzige Fabrik im Wallis verursacht ein Prozent der gesamten Treibhausgasemissionen der Schweiz. Dabei gibt es eine einfache Lösung für das Problem.'
        }
        author='Christoph Lenz'
      />
      <figcaption className='ui container'>Fotos: Fabian Hugo</figcaption>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Christoph Lenz</div>
            <div className='ta updated'>Aktualisiert am 23. Oktober 2020</div>
          </div>
          <div className='ta text'>
            <p>
              Ein unscheinbarer Quader, so gross wie ein Wohnblock. Der Quader
              steht in Visp, wenige Meter neben der Rhone, und gehört zum
              Chemieunternehmen Lonza. Darin verbirgt sich die klimaschädlichste
              Fabrik der Schweiz.
            </p>
            <p>
              D29 heisst das Gebäude im Lonza-Werkplan. Die Fabrik produziert
              zwei Dinge: den Nahrungsmittelzusatz Niacin; und als Abfallprodukt
              Lachgas. 1800 Tonnen davon entweichen jedes Jahr aus D29.
            </p>
            <p>
              Lachgas ist geruchlos. Und es ist nicht giftig. Aber zur
              Erderwärmung trägt es stärker bei als viele andere Treibhausgase.
              Lachgas ist rund zwölfmal so klimaschädlich wie Methan und rund
              dreihundertmal schädlicher als CO2.
            </p>
            <p>
              Das Lachgas von D29 hat einen Treibhauseffekt von etwa 550’000 bis
              600’000 Tonnen CO2 pro Jahr. Es macht über ein Prozent der
              gesamten Klimagasemissionen der Schweiz aus. Ein unglaublich hoher
              Anteil für eine einzelne Fabrik.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ padding: '0' }}>
        <div className='ui container'>
          <div className='ui equal width illustration grid stackable'>
            {!isTablet && (
              <div className='row'>
                <div className='column'>
                  <SvgWrapper
                    animation={Verkehr}
                    text={renderHTML(
                      'D29 stösst pro Jahr so viel Treibhausgas aus wie der <span>gesamte Verkehr in der Schweiz</span> (Autos, Lastwagen, Busse, Züge) während vierzehn Tagen.'
                    )}
                  />
                </div>

                <div className='column'>
                  <SvgWrapper
                    animation={Wallis}
                    text={renderHTML(
                      'D29 hat einen Klimaeffekt wie <span>acht Passagierflugzeuge</span>, die <span>ein Jahr nonstop</span> über dem Wallis kreisen.'
                    )}
                  />
                </div>

                <div className='column'>
                  <SvgWrapper
                    animation={Luzern}
                    text={renderHTML(
                      'D29 verursacht etwa denselben Klimaschaden wie die <span>ganze Stadt Luzern</span> mit allen Haushalten, dem ganzen Verkehr, der Industrie und der Landwirtschaft.'
                    )}
                  />
                </div>
              </div>
            )}
            {isTablet && (
              <React.Fragment>
                <div className='row'>
                  <div className='column'>
                    <SvgWrapper
                      animation={Verkehr}
                      text={renderHTML(
                        'D29 stösst pro Jahr so viel Treibhausgas aus wie der <span>gesamte Verkehr in der Schweiz</span> (Autos, Lastwagen, Busse, Züge) während vierzehn Tagen.'
                      )}
                    />
                  </div>

                  <div className='column'>
                    <SvgWrapper
                      animation={Wallis}
                      text={renderHTML(
                        'D29 hat einen Klimaeffekt wie <span>acht Passagierflugzeuge</span>, die <span>ein Jahr nonstop</span> über dem Wallis kreisen.'
                      )}
                    />
                  </div>
                </div>

                <div className='row halfCentered'>
                  <div className='column'>
                    <SvgWrapper
                      animation={Luzern}
                      text={renderHTML(
                        'D29 verursacht etwa denselben Klimaschaden wie die <span>ganze Stadt Luzern</span> mit allen Haushalten, dem ganzen Verkehr, der Industrie und der Landwirtschaft.'
                      )}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Lachgas beschleunigt nicht nur den Klimawandel. Bei seinem Abbau
              in der Stratosphäre greift es die Ozonschicht an. Von allen durch
              die Menschen freigesetzten Gasen ist Lachgas heute der grösste
              Ozonkiller.
            </p>
            <p>
              Erstaunlich an dem Lachgas, das aus dem Lonza-Werk entweicht, ist
              aber vor allem eines: Bis vor kurzem wusste niemand, dass es
              existiert.
            </p>
            <p>
              Am 10. Februar dieses Jahres verschickte das Bundesamt für Umwelt
              eine Medienmitteilung:{' '}
              <Link
                allowWordWrap
                href='https://www.bafu.admin.ch/bafu/de/home/dokumentation/medienmitteilungen/anzeige-nsb-unter-medienmitteilungen.msg-id-78041.html'
              >
                «Treibhausgasemissionen des Schweizer Industriesektors höher als
                angenommen.»
              </Link>{' '}
              Die Industrie stosse pro Jahr rund 600’000 Tonnen CO2-Äquivalente
              mehr aus als bisher bekannt. Ursache sei eine Lachgasquelle aus
              der Produktion der Lonza AG in Visp. Die Firma habe das Lachgas im
              Frühjahr 2018 festgestellt und anschliessend gemeldet. Das
              Bundesamt für Umwelt geht davon aus, dass das Lachgas seit fast
              fünfzig Jahren aus D29 austritt.
            </p>
            <p>
              Die Meldung flackerte kurz durch die Medien.{' '}
              <Link allowWordWrap href='30666809'>
                «Schweizer Klimabilanz ist schlechter als geglaubt»
              </Link>
              , titelten die Tamedia-Portale. «Korrektur der Klimabilanz»,
              meldete SRF. Dann wurde es still um D29.
            </p>
            <p>
              Wie ist so etwas möglich? Wie ist es möglich, dass ein global
              führender Chemiekonzern, der sich erst noch als Vorreiter einer
              grünen Industrie präsentiert, jahrelang nicht bemerkt, dass
              Tausende Tonnen Klimagas aus seiner Fabrik in den Himmel steigen?
              Dass auch die Walliser Umweltbehörden das Lachgas übersehen,
              obwohl sie die Abgase in den Lonza-Anlagen überwachen? Dass selbst
              beim Bund lange Zeit niemand darauf aufmerksam wird, trotz immer
              schärferer Umwelt- und Klimagesetze?
            </p>
            <p>
              Vor allem: Wie ist es möglich, dass nach Bekanntwerden des
              Problems niemand handelt und die Emissionen rasch stoppt?
            </p>
            <p>
              In den vergangenen sieben Monaten habe ich versucht, diese Fragen
              zu beantworten. Ich habe mit mehr als zwei Dutzend Experten für
              organische Chemie, Klimaphysik, Umweltschutz und Umweltrecht
              gesprochen. Ich habe ehemalige Mitarbeiter von D29 befragt. Ich
              habe chemische Fachliteratur studiert und, gestützt auf das
              Öffentlichkeitsgesetz, interne Unterlagen der Lonza und des Bundes
              eingesehen.
            </p>
            <p>
              Die Recherche zeigt, wie die Lonza und das Bundesamt für Umwelt
              das Problem verschleppten. Wie die Lonza die Lachgasemissionen
              fast zwei Jahre lang vor der Öffentlichkeit und den Aktionären
              verheimlichte. Wie die Lonza sich dagegen wehrte, die Kosten für
              die Neutralisierung des Lachgases selbst zu tragen. Und wie der
              Bund mit der Lonza einen Deal einging, der äusserst günstig ist
              für die Firma – ein Deal auf Kosten des Klimas.
            </p>
            <h5>Herbst 1971</h5>
            <h4 className='milestone'>Das wunderbare Vitamin aus Visp</h4>
            <p>
              Die Geschichte beginnt im Herbst 1971 mit der Einweihung der
              Fabrik D29, damals sprach man vom Niazolgebäude. Für die Lonza ist
              es ein Meilenstein. Schon seit den Fünfzigerjahren produziert das
              Unternehmen im Oberwallis synthetisches Niacin, einen
              Nahrungsmittelzusatz, der den Stoffwechsel stimuliert und auch als
              Nikotinsäure oder Vitamin B3 bekannt ist. Viele Menschen nehmen
              jeden Tag künstliches Niacin zu sich, etwa als Bestandteil eines
              Vitaminpräparates oder im Müesli.
            </p>
            <p>
              Mit den Produktionskapazitäten von D29 wird die Lonza 1971 auf
              einen Schlag zum Weltmarktführer für Niacin. Der Konzern ist es
              bis heute geblieben. In Visp und im südchinesischen Nansha stellt
              er jährlich rund 35’000 Tonnen des Pulvers her und erzielt damit
              schätzungsweise 300 Millionen Dollar Umsatz pro Jahr. Niacin ist
              einer der kommerziell bedeutendsten Stoffe der Lonza-Geschichte.
              Ein wunderbares Vitamin aus Visp.
            </p>
            <p>
              Die Lonza hat die Niacin-Produktion stetig verfeinert. Besonders
              stolz sind die Forscher auf ihre ökologischen Fortschritte: Im
              Jahr 2000 beispielsweise schilderte ein Lonza-Ingenieur in einem
              Fachartikel ein neues Oxidationsverfahren. Das Verfahren sei
              effizienter bezüglich CO2-Ausstoss, Wärme und Abfallprodukte.
              «Dieser Prozess zeigt, wie ernst es Lonza damit ist, ökonomische
              und ökologische Prinzipien in seinem Prozessmanagement zu
              verbinden.»
            </p>
            <p>
              Fünf Jahre später sprach ein Lonza-Wissenschaftler an einem
              Symposium der Swiss Chemical Society über Nachhaltigkeit. Die
              Niacin-Produktion sei «über mehr als fünfzig Jahre bis zum
              heutigen Tag bezüglich Wirtschaftlichkeit, Produktqualität und
              Ökologie weiterentwickelt und optimiert» worden, heisst es im
              Skript.
            </p>
            <p>
              Auch international präsentierte sich die Lonza als
              Pionierunternehmen einer nachhaltigen Niacin-Produktion. In einem
              Lehrmittel über «Green Chemistry» schrieb eine Lonza-Forscherin
              2011: Der Schlüssel für eine umweltfreundliche Chemie sei, «dass
              es ein Bewusstsein für alle Aspekte des Prozesses braucht».
            </p>

            <h5>26. April 2017</h5>
            <h4 className='milestone'>Und plötzlich ist da Lachgas</h4>

            <p>
              Dann kam der 26. April 2017. An jenem Tag führte die Lonza in D29
              eine Routinekontrolle für giftige Stickoxide durch. Die Ergebnisse
              machten die Techniker stutzig. Das Messgerät zeigte eine
              Stickoxidkonzentration an, die doppelt so hoch war wie gewohnt.
              Die Techniker hatten nur eine Erklärung für die enorme Abweichung:
              Sie hatten eine neue Messmethode angewandt. Bei einer näheren
              Untersuchung fanden sie Lachgas (Distickstoffmonoxid) in rauen
              Mengen.
            </p>
            <p>
              Warum hat die Lonza das Lachgas erst 2017 entdeckt? Und warum
              haben es die Umweltbehörden des Kantons Wallis und des Bundes
              ebenfalls nicht bemerkt? Die Antwort ist relativ einfach: Die
              Lonza <i>musste</i> das Lachgas nicht sehen. Die anderen{' '}
              <i>konnten</i> es nicht sehen. Lachgas ist in gewisser Weise ein
              blinder Fleck im Umweltrecht der Schweiz.
            </p>
            <p>
              Ein wesentlicher Teil unserer Umweltgesetze stammt aus den
              80er-Jahren. Damals ging es für die Politik noch nicht vorrangig
              ums Klima, sondern darum, Menschen, Tiere und lokale Lebensräume
              vor giftigen Stoffen zu schützen. Weil Lachgas nicht unmittelbar
              giftig ist, blieb es unreguliert.
            </p>
            <p>
              Daran hat sich bis heute nichts geändert. Obwohl sich die Schweiz
              mit der Unterzeichnung des Kyoto-Protokolls verpflichtet hat, die
              Treibhausgasemissionen zu reduzieren, gibt es für Lachgas weder
              Grenzwerte noch Kontrollpflichten.
            </p>
            <p>
              Ehemalige Mitarbeiter von D29 sagten gegenüber dem «Magazin»,
              ihnen sei zwar bewusst gewesen, dass bei der Niacin-Herstellung
              Lachgas entsteht, doch seien sie von sehr geringen Mengen
              ausgegangen. Überprüft habe man die Annahme nie, Lachgas sei
              schliesslich ungiftig. Ganz ähnlich klingt die offizielle
              Begründung der Lonza: Lachgasemissionen seien gesundheitlich
              unbedenklich und nicht in der Luftreinhalte-Verordnung geregelt,
              schrieb das Unternehmen im Februar 2020 in einer Medienmitteilung.
              Daher «waren im Rahmen der Niacin-Produktion keine Untersuchungen
              betreffend Lachgas vorgenommen worden».
            </p>
            <p>
              Aus demselben Grund haben auch die Walliser Umweltbehörden das Gas
              übersehen. Das kantonale Umweltamt kontrolliert Industrieanlagen
              nur auf jene Substanzen, die in der Luftreinhalte-Verordnung
              geregelt sind. Lachgas zählt nicht dazu.
            </p>
            <p>
              Und der Bund? Er unterhält zwar Messstationen in Davos und auf dem
              Jungfraujoch, die das Lachgas von D29 hätten registrieren können.
              Doch auch dort fiel nichts auf. Fachleute vermuten, dass die
              Oberwalliser Berggipfel das freigesetzte Gas gegen die
              Messstationen abschirmten.
            </p>
            <p>So produzierte D29 immer weiter. Niacin. Und Lachgas.</p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ padding: '0' }}>
        <LonzaAreal />
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h5>Frühling 2018</h5>
            <h4 className='milestone'>Die Lösung: ein Katalysator</h4>

            <p>
              Nach den ersten Messungen im April 2017 unterliess es die Lonza,
              die Behörden zu informieren. Stattdessen untersuchte man die
              Abgase aus D29 selbst und beauftragte ein externes Unternehmen mit
              einer Messung. Diese fand am 10. April 2018 statt. Seit den ersten
              Hinweisen auf Lachgas war fast ein Jahr verstrichen.
            </p>
            <p>
              Obwohl Lachgas ein viel potenteres Treibhausgas ist als CO2,
              spielt es in der öffentlichen Klimadebatte nur eine untergeordnete
              Rolle. Der Hauptgrund: Lachgas ist mengenmässig weniger bedeutend
              als CO2 und Methan. Hinzu kommt, dass die Klimapolitik dort
              ansetzt, wo Emissionen einfach reduziert werden können. Ein
              Grossteil des durch Menschen verursachten Lachgases fällt nicht in
              diese Kategorie. Es entsteht in der Landwirtschaft bei der
              Verwendung von Stickstoffdüngern. Das Gas steigt aus dem Boden auf
              und lässt sich kaum einfangen.
            </p>
            <p>
              Anders liegt die Sache, wenn Lachgas konzentriert entsteht, etwa
              in der Industrie. Katalysatoren können das Gas nahezu vollständig
              neutralisieren. Sie wandeln das extrem klimaschädliche Lachgas
              (N2O) in Stickstoff (N2) und Sauerstoff (O2) um. Aus Lachgas wird
              Luft.
            </p>
            <p>
              Auch bei der Lonza kennt man diese Katalysatoren. Nach der
              Entdeckung der Emissionen in D29 plant die Firma im Frühling 2018
              den Einbau eines Modells von ThyssenKrupp. Damit könne der
              Ausstoss um mehr als 98 Prozent verringert werden, heisst es in
              einem internen Dokument. Statt 5 Tonnen Lachgas pro Tag würde D29
              dann nur noch rund 75 Kilogramm ausstossen.
            </p>
            <p>
              Der Katalysator könnte ab dem dritten Quartal 2019 wirksam sein,
              schreibt die Lonza 2018. Die Kosten betragen 12 Millionen Franken,
              eine überschaubare Summe für einen 6-Milliarden-Konzern. Dennoch
              ist in Visp bis heute nichts von einem Katalysator zu sehen. Der
              Grund: Die Lonza wollte den Einbau nicht selbst bezahlen.
            </p>
            <h5>25. Mai 2018</h5>
            <h4 className='milestone'>
              Lonza informiert den Bund – und will Geld
            </h4>
            <p>
              Am 25. Mai 2018 betritt eine Lonza-Delegation die Zentrale des
              Bundesamtes für Umwelt im Berner Vorort Ittigen. Die
              Firmenvertreter haben sich gut vorbereitet. Es geht für die Lonza
              nicht nur um 12 Millionen, sondern um viel mehr Geld.
            </p>
            <p>
              Um die Stimmung zu heben, eröffnen die Lonza-Vertreter die Sitzung
              mit guten Neuigkeiten – einer kleinen Emissionsreduktion in der
              Visper Benzinspaltanlage. Dann kommen sie auf D29 zu sprechen.
              Auch hier betont die Lonza das Positive. Mit einem Katalysator
              könne der Lachgasausstoss aus dem Niacin-Prozess stark reduziert
              werden, heisst es in dem Besprechungsbericht. «Lonza plant, einen
              Katalysator zu installieren.»
            </p>
            <p>
              Die Firmenvertreter stellen nur eine Bedingung: Der Bau dieser
              Anlage müsse vom Bund als CO2-Kompensationsprojekt anerkannt
              werden. Denn ohne den Erlös aus dem Verkauf von
              CO2-Bescheinigungen sei das Projekt «nicht wirtschaftlich und wird
              deshalb nicht realisiert». Das Unternehmen will also dafür bezahlt
              werden, dass es aufhört, das Klima zu belasten. Sonst läuft D29
              einfach weiter.
            </p>
            <p>
              Grundsätzlich ist das nichts Ungewöhnliches. Ein Grossteil der
              Schweizer Klimastrategie basiert auf der Idee, dass finanzielle
              Anreize die Unternehmen, Haushalte und Bürger ermutigen können,
              ihren Treibhausgasausstoss zu reduzieren.
            </p>
            <p>
              Nach diesem Prinzip funktionieren auch die sogenannten
              Kompensationsprojekte. Wer Emissionen mit freiwilligen Massnahmen
              vermindert, kann die CO2-Einsparung an eine Stiftung der Schweizer
              Mineralölindustrie verkaufen. Pro Tonne CO2-Reduktion zahlte die
              Stiftung 2019 durchschnittlich 95 Franken.
            </p>
            <p>
              Oft sind die Investitionskosten mit diesem Beitrag noch nicht
              vollständig gedeckt. Manchmal schaut aber für den Verursacher der
              Emission sogar ein Gewinn raus. Danach sah es auch bei D29 aus.
              Weil die Anlage so viel Treibhausgas ausstösst und der Preis für
              einen Katalysator vergleichsweise tief ist, winken der Lonza mit
              dem Verkauf ihres Klimaschadens Dutzende Millionen Franken Profit.
            </p>
            <p>
              Ein Problem gab es allerdings: Die Lonza gehört zu den Unternehmen
              mit dem höchsten Treibhausgasausstoss der Schweiz und kommt gemäss
              CO2-Gesetz für Kompensationsprojekte gar nicht infrage. Für Firmen
              wie die Lonza gilt ein strengeres Regelwerk, das sogenannte
              Emissionshandelssystem.
            </p>
            <p>
              Dieses System funktioniert so: Der Bund verteilt jedes Jahr eine
              bestimmte Zahl kostenloser Emissionszertifikate an die
              teilnehmenden Firmen. Diese Zertifikate berechtigen die
              Unternehmen, Treibhausgase auszustossen. Ende Jahr wird
              abgerechnet. Für jede effektiv emittierte Tonne Treibhausgas muss
              das Unternehmen ein Emissionszertifikat einreichen. Hat ein
              Unternehmen dafür nicht genügend Zertifikate, muss es die
              fehlenden hinzukaufen.
            </p>
            <p>
              Weil der Bund die Zahl der ausgeteilten Gratiszertifikate jedes
              Jahr um rund zwei Prozent reduziert, entsteht ein Anreizsystem:
              Tun Firmen nichts, um ihre Klimaeffizienz zu verbessern, müssen
              sie immer mehr Zertifikate hinzukaufen. Schafft es ein Unternehmen
              hingegen, seinen Ausstoss zu senken, kann es die überschüssigen
              Gratiszertifikate des Bundes weiterverkaufen oder für später
              sparen.
            </p>
            <p>
              Kompensationsprojekt oder Emissionshandel? Im Mai 2018 ist das für
              die Lonza eine Multimillionen-Franken-Frage. Entweder die Firma
              erhält Geld aus dem Topf der Mineralölindustrie, um das
              Lachgas-Problem aus der Welt zu schaffen. Oder sie muss den
              Katalysator selber finanzieren und zudem Emissionszertifikate für
              das Lachgas erwerben, das bis zum Einbau des Katalysators aus D29
              austritt.
            </p>
            <p>
              Die Lonza beharrt in den Verhandlungen mit dem Bund von Mai 2018
              bis im Herbst 2019 darauf, den Katalysator als
              Kompensationsprojekt realisieren zu dürfen – trotz rechtlicher
              Einwände. Dies ist ein wichtiger Grund, warum der
              Lachgaskatalysator immer noch nicht in Betrieb ist.
            </p>
            <h5>Sommer 2018</h5>
            <h4 className='milestone'>Beim Bund passiert - praktisch nichts</h4>
            <p>
              Ein anderer Grund findet sich in Ittigen, beim Bundesamt für
              Umwelt. Wie reagiert eine Umweltbehörde auf die Nachricht, dass in
              ihrem Zuständigkeitsbereich eine riesige und einfach vermeidbare
              Quelle von Treibhausgas entdeckt wurde? Mit Sofortmassnahmen,
              würde man meinen.
            </p>

            <p>
              Im Bundesamt für Umwelt ist das Gegenteil der Fall. Nach dem 25.
              Mai 2018, dem Tag, an dem die Lonza die Behörden über das
              Lachgasproblem informierte, passiert wenig. Das Unternehmen reicht
              zwar schon Mitte Juni eine achtseitige Projektskizze für den Bau
              des Katalysators als Kompensationsprojekt ein. Doch als die Lonza
              sich im Juli beim Bundesamt nach dem Stand der Dinge erkundigt,
              schreibt ein Beamter zurück: «Leider kann ich Ihnen keinen festen
              Termin für die Rückmeldung mitteilen.» Die Kollegen seien bis Ende
              Juli «ferienhalber abwesend».
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment evidence' style={{ padding: '0' }}>
        <img
          className='ui image fluid'
          src={require(isMobile
            ? '../../images/ausriss-emission-top-mobile.jpg'
            : '../../images/ausriss-emission-top.jpg')}
        />
        <img
          className='ui image fluid'
          src={require(isMobile
            ? '../../images/ausriss-emission-bottom-mobile.jpg'
            : '../../images/ausriss-emission-bottom.jpg')}
        />
        <div className='ui container'>
          <figcaption className='ui container'>
            Eine Projektskizze der Lonza zeigt, dass der Konzern den
            Lachgas-Katalysator schon 2019 einbauen wollte. Der Ausstoss von
            mehr als einer Million Tonnen CO2-Äquivalenten in den Jahren 2020
            und 2021 hätte so gegenüber dem heutigen Planungsstand vermieden
            werden können.
          </figcaption>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Als das Amt am 22. August 2018 endlich antwortet, handelt es sich
              nur um eine «erste, freiwillige Vorprüfung». Das Bundesamt für
              Umwelt weist die Lonza auf die Gesetzeslage hin, wonach
              Unternehmen, die dem Emissionshandelssystem unterstehen, für
              Kompensationsprojekte nicht infrage kommen. Zudem gebe es
              Unklarheiten in der Projektskizze.
            </p>
            <p>
              Wenige Tage später fragt die Lonza nach, wie die Unklarheiten
              beseitigt werden können. Wieder dauert es vier Wochen, bis das
              Bundesamt antwortet. Es sei noch zu klären, wo genau im
              Niacin-Herstellungsprozess das Lachgas entsteht.
            </p>
            <p>
              Am 1. Oktober 2018 entscheidet das Bundesamt für Umwelt, die Frage
              extern abklären zu lassen. Das Gutachten trifft erst fünf Monate
              später ein, im März 2019. Es hält fest, dass das Lachgas bei der
              Niacin-Synthese entsteht. Genau das hatte die Lonza dem Bund
              bereits neun Monate zuvor mitgeteilt.
            </p>
            <p>
              Eine weitere Verzögerung entsteht, weil die Umweltbehörde
              inzwischen ein zweites Gutachten in Auftrag gegeben hat. Sie will
              von einem Institut in Deutschland wissen, wie die EU mit der
              Niacin-Anlage der Lonza verfahren würde. Die Kurzfassung: «Es gibt
              keine vergleichbare Anlage in der EU.» Als das Gutachten
              eintrifft, ist es Juni 2019.
            </p>
            <h5>Juni 2019</h5>
            <h4 className='milestone'>
              Noch immer ist der Katalysator blockiert
            </h4>
            <p>
              Über ein Jahr ist nun vergangen, seit das Bundesamt für Umwelt von
              dem Lachgasproblem in D29 erfahren hat. In der Zwischenzeit hat
              SP-Bundesrätin Simonetta Sommaruga das Umweltdepartement
              übernommen und eindringlich mehr Klimaschutz gefordert. Doch
              einige Etagen tiefer setzt der Fall Lonza Staub an.
            </p>
            <p>
              Beim Einbau des Katalysators herrscht Blockade. Der Konflikt ist
              Mitte 2019 der gleiche wie im Mai 2018: Die Lonza will immer noch
              Geld aus dem Topf für Kompensationsprojekte. Das Bundesamt für
              Umwelt hat weiterhin rechtliche Bedenken. Derweil läuft D29
              einfach weiter. 5 Tonnen Lachgas pro Tag. Umgerechnet 1500 Tonnen
              CO2.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ padding: '0' }}>
        <div className='ui text container'>
          <EmissionCounter />
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Firmengeschichte der Lonza ist reich an Umweltskandalen. In
              jüngster Zeit bemüht sich das Unternehmen aber um eine
              Imagekorrektur. Ein Schlüsselereignis bildet die Wahl von Albert
              M. Baehny zum Präsidenten der Lonza. Unter Baehny verpflichtet
              sich die Firma 2018 auf die UNO-Klimaschutzziele. Unter Baehny
              wird erstmals ein umfangreicher Nachhaltigkeitsbericht erstellt.
              Unter Baehny ruft die Lonza sogar einen eigenen «Sustainability
              Council» ins Leben. Dieser untersteht direkt der Geschäftsleitung
              und soll den Nachhaltigkeitsgedanken im ganzen Konzern stärken.
            </p>
            <p>
              Der grüne Kurs bleibt dabei explizit Chefsache. «Die ultimative
              Verantwortung für alle Nachhaltigkeitsfragen liegt beim
              Präsidenten des Verwaltungsrats», schreibt die Lonza Anfang 2019.
              Also bei Albert M. Baehny. Die Werte des Unternehmens fasst Baehny
              so zusammen: «Wir messen unseren Erfolg nicht nur an Umsatz und
              Gewinn. Sondern auch daran, wie viel wir unseren Leuten und
              Gemeinden zurückgeben und zum Schutz der Umwelt beitragen können.»
            </p>
            <p>
              In den Verhandlungen mit dem Bund hat der Schutz der Umwelt für
              die Lonza allerdings keine Priorität. Entscheidend ist, nicht für
              den Einbau des Katalysators bezahlen zu müssen.
            </p>

            <h5>26. Juli 2019</h5>
            <h4 className='milestone'>Der Bazar um D29 beginnt</h4>

            <p>
              Am 26. Juli 2019, gut ein Jahr nach der ersten Zusammenkunft,
              trifft um 8.30 Uhr erneut eine Delegation der Lonza in Ittigen
              ein. Nun erfahren die Firmenvertreter, dass ein
              Kompensationsprojekt definitiv nicht möglich ist. Zu gross sind
              die Einwände der Rechtsabteilung des Bundesamts für Umwelt.
            </p>

            <p>
              Stattdessen macht der Bund ein Angebot: Die Lonza zahlt den
              Katalysator selbst, wird aber für 2018 von der Verpflichtung
              entbunden, Emissionszertifikate für das Lachgas zu kaufen. Für die
              Jahre 2019 und 2020 soll die Firma ausserdem
              Gratis-Emissionszertifikate aus einer Reserve des Bundes erhalten.
              Weil aber die Reserve nicht ausreicht, müsste die Lonza
              zusätzliche Zertifikate kaufen. Simonetta Sommaruga, heisst es im
              Protokoll, werde über den Entscheid informiert.
            </p>
            <p>
              Das Angebot der Umweltbeamten zeugt von einer besonderen Mischung
              aus Fantasie und Formalismus: Das Amt stellt sich gemäss Protokoll
              der Sitzung auf den Standpunkt, das Lachgas sei erst durch das
              externe Gutachten vom März 2019 nachgewiesen worden. «Rechtlich
              handelt es sich deshalb um neue Emissionen.» Daher müsse die Lonza
              keine Zertifikate für die Zeit vor dem Gutachten einreichen.
              Tausende Tonnen Lachgas – einfach gestrichen.
            </p>
            <p>
              Doch die Lonza akzeptiert auch dieses grosszügige Angebot nicht.
              Am 13. August beklagt sich der Konzern über die «grossen
              finanziellen Auswirkungen». Es brauche eine Übergangsregelung für
              die Jahre 2019 und 2020, weil man erst ab 2021 damit rechnen
              könne, dass die Lachgasemissionen in der Verteilung der
              Gratiszertifikate angemessen berücksichtigt würden.
            </p>
            <h5>4. September 2019</h5>
            <h4 className='milestone'>Und wieder knickt Bern ein</h4>
            <p>
              Am 4. September macht der Bund erneut ein Zugeständnis: Auch für
              2019 muss die Lonza nun keine Emissionszertifikate einreichen und
              spart damit bis zu 10 Millionen Franken. Doch selbst das reicht
              dem Konzern nicht. Die Rechtsabteilung erhöht den Druck auf das
              Bundesamt, die Lonza spielt ihre stärkste Karte: die 3000
              Arbeitsplätze in Visp. «Wir wollen weder die Umwelt noch den
              Standort Visp gefährden», heisst es in einem Schreiben vom 16.
              September 2019. Falls man aber für 2020 Emissionszertifikate für
              12 Millionen Franken kaufen müsse, «wird eine Verlagerung der
              Niacin-Produktion nach China mit in Betrachtung gezogen, dadurch
              werden Arbeitsplätze in Visp bedroht. Eine Verlagerung würde den
              Standort als Gesamtes schwächen, ja sogar bedrohen.»
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment evidence' style={{ padding: '0' }}>
        <img
          className='ui image fluid'
          src={require(isMobile
            ? '../../images/ausriss-china-top-mobile.jpg'
            : '../../images/ausriss-china-top.jpg')}
        />
        <img
          className='ui image fluid'
          src={require(isMobile
            ? '../../images/ausriss-china-bottom-mobile.jpg'
            : '../../images/ausriss-china-bottom.jpg')}
        />
        <div className='ui container'>
          <figcaption className='ui container'>
            «Standort Visp bedroht»: Lonza kämpfte mit harten Bandagen für
            Zugeständnisse des Bundesamtes für Umwelt.{' '}
          </figcaption>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Drohung wirkt. Am 13. November 2019 einigen sich die beiden
              Parteien darauf, dass die Lonza auch im Jahr 2020 für die 1800
              Tonnen Lachgas keine Emissionsrechte an der Börse kaufen muss.
              Stattdessen erhält der Konzern Gratis-Emissionsrechte des Bundes,
              einen Teil als Vorschuss für das Jahr 2021. Im Gegenzug
              verpflichtet sich die Lonza, «den Kombi-Katalysator nach
              allfälligem Testbetrieb bis spätestens Ende 2021 in Betrieb zu
              nehmen».
            </p>
            <p>
              Mit anderen Worten: D29 darf zwei Jahre weiterlaufen. Das
              Bundesamt für Umwelt nimmt damit zusätzliche Emissionen von 1,2
              Millionen Tonnen CO2-Äquivalenten in Kauf.
            </p>
            <h5>September 2020</h5>
            <h4 className='milestone'>Das Bundesamt und die Kostenfrage</h4>
            <p>
              Warum hat das Amt nicht rascher gehandelt? Nicht auf eine schnelle
              Lösung gedrängt? Andrea Burkhardt, die Klima-Chefin im Bundesamt
              für Umwelt, sitzt Ende September 2020 in einem engen
              Besprechungsraum am Hauptsitz der Behörde. Sie wehrt sich gegen
              den Vorwurf, das Lachgasproblem verschleppt zu haben. Zwar hätten
              die zwei Gutachten viel Zeit beansprucht, so Burkhardt. Doch
              erstens habe man zweifelsfrei feststellen müssen, wo in der
              Niacin-Produktion das Lachgas entsteht. «Das war eine
              Voraussetzung, um die Emissionen dem Emissionshandelssystem zu
              unterstellen.»
            </p>
            <p>
              Zweitens habe sich der Bund für den Fall absichern müssen, dass
              die Auseinandersetzung mit der Lonza vor Gericht endet. «Dann
              hätte es wohl noch viel länger gedauert, bis der Katalysator in
              Betrieb genommen wird.»
            </p>
            <p>
              Aber warum haben die Behörden nicht mehr Druck auf das Unternehmen
              gemacht? «Wir haben geprüft, ob wir Lonza verpflichten können, den
              Katalysator sofort einzubauen», sagt Burkhardt. «Doch dafür gibt
              es keine Rechtsgrundlage, weil Lachgas nicht in der
              Luftreinhalte-Verordnung geregelt ist.» Um trotzdem eine rasche
              Lösung zu finden, habe man Lonza die Emissionsrechte für 2018 und
              2019 erlassen. «Es hätte auch niemandem etwas gebracht, wenn Lonza
              diese auf dem Markt gekauft hätte. Es hätte nur Kosten
              verursacht», sagt Burkhardt.
            </p>
            <p>
              Dass diese Kosten auch ein Mittel gewesen wären, um Lonza zu einem
              raschen Bau des Katalysators zu motivieren - das sieht man im
              Bundesamt für Umwelt nicht.
            </p>
            <h5>2018 bis 2020</h5>
            <h4 className='milestone'>
              Wie die Lonza und der Bund das Lachgas versteckten
            </h4>
            <p>
              Es gibt wohl noch einen weiteren Grund, warum das Lachgasproblem
              in Visp nicht entschiedener angegangen wurde: Die Öffentlichkeit,
              die Umweltverbände, das Parlament, ja selbst die Aktionäre der
              Lonza, also alle, die Druck hätten machen können, wurden die ganze
              Zeit im Dunkeln gelassen.
            </p>
            <p>
              Obwohl Lonza schon im Frühling 2018 wusste, wie viel Lachgas aus
              D29 entweicht, wurden die Emissionen fast zwei Jahre lang
              verschwiegen. Im März 2019 präsentierte der Konzern den Aktionären
              falsche Zahlen zum Treibhausgasausstoss der Gruppe – das Lachgas
              wurde einfach weggelassen. Der Effekt ist bemerkenswert: Die
              tatsächlichen direkten Emissionen waren rund doppelt so hoch wie
              jene, die die Lonza im Geschäfts- und Nachhaltigkeitsbericht 2018
              auswies.
            </p>
            <p>
              Im neuen Nachhaltigkeitsbericht, der dieses Jahr publiziert wurde,
              schreibt Lonza, die Lachgasemission sei erst «2019 quantifiziert»
              worden. Dokumente, die dem «Magazin» vorliegen, zeigen jedoch,
              dass dies nicht der Wahrheit entspricht. Die Messungen fanden
              schon 2018 statt.
            </p>
            <p>
              Falsche Angaben in Geschäftsberichten können das Vertrauen der
              Aktionäre schwächen und institutionelle Anleger zum Handeln
              zwingen. Die Lonza-Aktie bildet in vielen Nachhaltigkeitsfonds von
              Schweizer Banken (z. B. UBS, Raiffeisen, Vontobel, Basler
              Kantonalbank) eine wichtige Position. Einige dieser
              Nachhaltigkeitsfonds haben im Jahr der falsch rapportierten
              Emissionszahlen markant Lonza-Aktien hinzugekauft. Diese Fonds
              könnten unter Druck der Anleger geraten.
            </p>
            <p>
              Selbst das Bundesamt für Umwelt half bei der Verheimlichung mit:
              Grosse Industriebetriebe sind verpflichtet, ihre
              Umweltverschmutzung in das Schweizer Schadstoffregister
              einzutragen. Obwohl die Lonza die Behörden im Mai 2018 über den
              Ausstoss von jährlich rund 1800 Tonnen Lachgas informierte, liess
              das Unternehmen in jenem Jahr nur 25 Tonnen ins Register
              eintragen.
            </p>
            <p>
              Das Bundesamt für Umwelt, das für die Durchsetzung der
              Meldepflicht verantwortlich ist, duldete dies: Die Menge sei
              damals noch nicht zweifelsfrei bestimmt gewesen, erklärt das Amt.{' '}
            </p>

            <h5>Oktober 2020</h5>
            <h4 className='milestone'>
              Noch mehr Verspätung für den Katalysator
            </h4>

            <p>
              Doch was sagt Lonza-Präsident Albert M. Baehny zur
              klimaschädlichsten Fabrik der Schweiz? Warum hat der Konzern die
              Emissionen von D29 verheimlicht? Warum hat die Lonza den Bau des
              Katalysators nicht rascher vorangetrieben? Und wie passt all das
              zum Bekenntnis des Unternehmens zu Umwelt- und Klimaschutz?
            </p>
            <p>
              Gerne hätte ich diese Fragen persönlich an Albert M. Baehny
              gerichtet. Ein Gespräch mit dem Lonza-Präsidenten sei aber nicht
              möglich, beschied mir die Medienstelle. Stattdessen schickte das
              Unternehmen eine schriftliche Stellungnahme Baehnys.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ padding: '0' }}>
        <img
          className='ui image fluid'
          src={require(isMobile
            ? '../../images/albert-baehny-mobile.jpg'
            : '../../images/albert-baehny.jpg')}
        />
        <div className='ui container'>
          <figcaption className='ui container'>
            Sein Konzern habe «mit Hochdruck» an der technisch anspruchsvollen
            Katalysator-Lösung gearbeitet, sagt Lonza-Präsident Albert M.
            Baehny.{isMobile && ' '}
            {!isMobile && <br />}
            Foto: Kostas Maros (Bilanz)
          </figcaption>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Für den Konzernchef hat die Lonza keine Fehler gemacht, weder vor
              2017 noch danach. Selbst ein Bedauern darüber, dass bis zum Einbau
              des Katalysators so viel Zeit verstreicht, lässt sich dem
              Schreiben nicht entnehmen. Vielmehr sei es nur der Lonza zu
              verdanken, dass die Emissionen von D29 heute überhaupt bekannt
              sind: «Ich erinnere Sie daran, dass es die Lonza war, die auf die
              Lachgas-Thematik aufmerksam wurde, und dass es die Lonza war, die
              das Thema gegenüber dem Bund und der Öffentlichkeit transparent
              gemacht hat.» Zudem sei die Firma bestrebt, die Emissionen zu
              minimieren, «auch wenn keine regulatorischen Grenzwerte
              einzuhalten sind».
            </p>
            <p>
              Dass die Lonza dem Bund eine Verlagerung der Niacin-Produktion
              nach China in Aussicht gestellt hatte, will er nicht als Drohung
              verstanden wissen. Für solche Projekte sei es «durchaus üblich,
              verschiedene Optionen zu prüfen». Die Lonza trage auch keine
              Verantwortung dafür, dass sich der Katalysator um Jahre
              verzögerte. Man habe «mit Hochdruck» an der anspruchsvollen
              technischen Lösung gearbeitet. Auch habe eine Baubewilligung
              eingeholt werden müssen. Die Pläne für eine Inbetriebnahme im
              dritten Quartal 2019 hätten sich «als zu optimistisch erwiesen».
            </p>
            <p>
              Zu optimistisch war auch die Ankündigung, den Katalysator bis
              August 2021 zu erstellen. Die mit dem Bund vereinbarte Frist bis
              Ende 2021 wird Lonza ebenfalls nicht schaffen. Die Inbetriebnahme
              ist nun fürs erste Quartal 2022 geplant. Doch nicht einmal das ist
              sicher: Es gelte der «Vorbehalt» eingehaltener Fristen durch die
              Lieferanten, so die Lonza-Medienstelle.
            </p>
            <p>
              Somit werden von den ersten Hinweisen auf das Lachgas bis zu
              seiner Neutralisierung fast fünf Jahre vergangen sein. Fast 9000
              Tonnen Lachgas hat D29 in dieser Zeit produziert. Umgerechnet 2,7
              Millionen Tonnen CO2. Und all das wegen einer winzigen
              Gesetzeslücke, einer trägen Umweltbehörde und einer Firma, die den
              Katalysator für das von ihr verursachte Klimagas nicht selbst
              bezahlen wollte.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical inverted segment'>
        <div className='ui container gasses'>
          <h2>Die drei wichtigsten Treibhausgase</h2>
          <div className='ui equal width grid stackable'>
            <div className='row'>
              <div className='column'>
                <Gas
                  name={renderHTML('Kohlendioxid (CO<sub>2</sub>)')}
                  sources='Verkehr, Industrie, Energiegewinnung'
                  formula={require('images/co2.gif')}
                  text='Kohlendioxid ist das mit Abstand bedeutendste Treibhausgas, das auf menschliche Aktivitäten zurückzuführen ist. Es macht rund 81 Prozent des globalen Klimagas-Ausstosses aus. Kohlendioxid entsteht hauptsächlich bei der Verbrennung fossiler Brennstoffe wie Kohle, Erdöl oder Erdgas. Es wird aber auch bei verschiedenen chemischen Reaktionen freigesetzt, etwa bei der Herstellung von Zement. In der Schweiz sind die Hauptquellen von CO2 der Verkehr, die Industrie und die Haushalte. Seit 1990 konnten die CO2-Emissionen um rund 17 Prozent gesenkt werden. 2018 beliefen sie sich auf rund 37 Millionen Tonnen. '
                />
              </div>

              <div className='column'>
                <Gas
                  name={renderHTML('Methan (CH<sub>4</sub>)')}
                  potential='25 Mal stärker als CO<sub>2</sub>'
                  sources='Rohstoffabbau, Landwirtschaft, Abfall'
                  formula={require('images/ch4.gif')}
                  text='Methan hat einen Anteil von gut 10 Prozent der schweizerischen Treibhausgasemissionen. In der Schweiz stammt es hauptsächlich aus der Landwirtschaft (Rindviehhaltung und Gülle-Düngung) und aus der Abfallbewirtschaftung. Im Ausland stösst auch der Abbau von Kohle und die Gewinnung von Erdgas viel Methan aus. Während der weltweite Methan-Ausstoss unvermindert wächst, konnte die Schweiz ihre Bilanz seit 1990 um rund 20 Prozent verbessern. Die Haupttreiber dieser Entwicklung waren die Verringerung des Kuhbestandes in der Landwirtschaft und Verbesserungen beim Umgang mit Abfalldeponien.'
                />
              </div>
            </div>

            <div className='row'>
              <div className='column'>
                <Gas
                  name={renderHTML('Lachgas (N<sub>2</sub>0)')}
                  potential='298 Mal stärker als CO<sub>2</sub>'
                  sources='Landwirtschaft, Industrie'
                  formula={require('images/n2o.gif')}
                  text={renderHTML(
                    'Lachgas ist mit einem Anteil von 7 Prozent das drittwichtigste Treibhausgas. Hauptquelle in der Schweiz ist die Landwirtschaft. Das Lachgas entsteht hier unter anderem aufgrund der Verwendung von Stickstoffdüngern. Doch auch in der Industrie werden namhafte Mengen freigesetzt. Die Lonza Fabrik D29 in Visp macht alleine rund 18 Prozent der schweizerischen Lachgas-Emissionen aus. Während der inländische Ausstoss tendenziell sinkt, nehmen die globalen Emissionen stark zu. Grund ist die Nahrungsversorgung in den Schwellenländern. Ein internationales Forschungskonsortium mit Beteiligung der Universität Bern <Link href=`353376815471`>warnte Anfang Oktober</Link>, dass der steigende Lachgas-Ausstoss die Erreichung der Ziele des Pariser Klimaabkommens gefährdet.'
                  )}
                />
              </div>

              <div className='column'>&nbsp;</div>
            </div>
          </div>
        </div>
      </div>

      <Footer
        inverted
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text', 'Christoph Lenz, Das Magazin'],
          ['Fotos', 'Fabian Hugo'],
          ['Digitale Umsetzung, Illustration', 'Mathias Lutz']
        ]}
        mediaName='dasmagazin'
        fullMediaName='Das Magazin'
        hidePortfolioTeaser
      />
    </div>
  )
}
